module.exports = __webpack_public_path__ + "a6ae2d1e20639461944ac1da312f5557.svg";